module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-footer-img.5970a0f2.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-footer-img.png
// module id = 3163
// module chunks = 11